import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/download/basic_trade',
    name: 'home',
    component: () => import('../views/DownLoad01.vue')
  },
  {
    path: '/download/block_trade',
    name: 'home',
    component: () => import('../views/DownLoad02.vue')
  },
  {
    path: '/download/social_trade',
    name: 'home',
    component: () => import('../views/DownLoad03.vue')
  },
  {
    path: '/terms_of_service',
    name: 'home',
    component: () => import('../views/TOS.vue')
  },
  {
    path: '/tos/:lang?',
    name: 'home',
    component: () => import('../views/TOS.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
